/**
 * Dashboard Translations (EN/ES) - Barrel Export
 *
 * Merges all per-feature translation modules and derives TranslationKeys type.
 * Default language is Spanish (target market).
 */

import { common } from "./common";
import { navigation } from "./navigation";
import { auth } from "./auth";
import { dashboard } from "./dashboard";
import { settings } from "./settings";
import { myRequests } from "./my-requests";
import { serviceRequests } from "./service-requests";
import { serviceCatalog } from "./service-catalog";
import { pricing } from "./pricing";
import { companies } from "./companies";
import { tickets } from "./tickets";
import { team } from "./team";
import { socialMedia } from "./social-media";
import { notifications } from "./notifications";
import { approvals } from "./approvals";
import { designSystem } from "./design-system";
import { websiteContent } from "./website-content";
import { talent } from "./talent";
import { questionnaires } from "./questionnaires";
import { wizard } from "./wizard";
import { guidance } from "./guidance";
import { brandAssets } from "./brand-assets";
import { planning } from "./planning";
import { projects } from "./projects";
import { pipeline } from "./pipeline";
import { mcp } from "./mcp";

export const translations = {
  en: {
    common: common.en,
    navigation: navigation.en,
    // Keep flat top-level keys for backwards compat with existing consumers
    sidebar: navigation.en.sidebar,
    menu: navigation.en.menu,
    user: navigation.en.user,
    navbar: navigation.en.navbar,
    auth: auth.en,
    dashboard: dashboard.en,
    settings: settings.en,
    myRequests: myRequests.en,
    serviceRequests: serviceRequests.en,
    // Keep flat key for backwards compat
    serviceRequestsNew: serviceRequests.en,
    serviceRequestSuccess: serviceRequests.en.success,
    serviceCatalog: serviceCatalog.en,
    pricing: pricing.en,
    companies: companies.en,
    tickets: tickets.en,
    team: team.en,
    socialMedia: socialMedia.en,
    notifications: notifications.en,
    approvals: approvals.en,
    designSystem: designSystem.en,
    websiteContent: websiteContent.en,
    talent: talent.en,
    questionnaires: questionnaires.en,
    wizard: wizard.en,
    guidance: guidance.en,
    brandAssets: brandAssets.en,
    planning: planning.en,
    projects: projects.en.projects,
    pipeline: pipeline.en.pipeline,
    mcp: mcp.en,
  },
  es: {
    common: common.es,
    navigation: navigation.es,
    sidebar: navigation.es.sidebar,
    menu: navigation.es.menu,
    user: navigation.es.user,
    navbar: navigation.es.navbar,
    auth: auth.es,
    dashboard: dashboard.es,
    settings: settings.es,
    myRequests: myRequests.es,
    serviceRequests: serviceRequests.es,
    serviceRequestsNew: serviceRequests.es,
    serviceRequestSuccess: serviceRequests.es.success,
    serviceCatalog: serviceCatalog.es,
    pricing: pricing.es,
    companies: companies.es,
    tickets: tickets.es,
    team: team.es,
    socialMedia: socialMedia.es,
    notifications: notifications.es,
    approvals: approvals.es,
    designSystem: designSystem.es,
    websiteContent: websiteContent.es,
    talent: talent.es,
    questionnaires: questionnaires.es,
    wizard: wizard.es,
    guidance: guidance.es,
    brandAssets: brandAssets.es,
    planning: planning.es,
    projects: projects.es.projects,
    pipeline: pipeline.es.pipeline,
    mcp: mcp.es,
  },
} as const;

/** Type-safe translation keys derived from the English translations object */
export type TranslationKeys = (typeof translations)["en"];

export type Language = "en" | "es";
